/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import _ from 'lodash';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { tabHighLigther } from '../../../SharedModules/utilities/utilities';
import {
  getProvider,
  dispatchGetCommonData,
  FETCHALLPROVIDERLIST,
  dispatchGetDetailData,
  handleErrorMessages,
  getNdcMainGridDetail,
  dispatchProviderFrozenComplete,
  dispatchProblemCode,
  dispatchcorrectionCode,
  dispatchProviderReviewClaimHeader,
  dispatchBottonState,
} from './Store/actions';
import { getProviderIdTypeDetails } from '../../Display/Provider/store/action';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import { TableHeaderForProviderReview } from './gridComponents/PRTableComponent';
import { viewPortHeight_355 } from '../../../SharedModules/CommonConstants/commonConstants';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';

const ProviderReview = () => {
  const errorMessagesInRedux = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.errorMessagesInRedux
  );
  const getProviderList = useSelector(
    (state) => state.sharedState.ProviderReviewReducer?.getProviderList
  );
  const providerIdTypeDropDown = useSelector(
    (state) => state?.sharedState?.ProviderReducer?.providerIdType
  );
  const dispatch = useDispatch();

  // 1st Scrren 1st table data Population
  const getProviderFromRedux = useSelector(
    (val) => val.sharedState.ProviderReviewReducer?.getProviderData
  );
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  // mainatin redux/state for 1st screen checkbox
  const fetchCommonData = useSelector(
    (val) => val.sharedState.ProviderReviewReducer?.getCommonData
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const setCommonData = (value) => dispatch(dispatchGetCommonData(value));
  const history = useHistory();
  const [tableclick, settableclick] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [checkBoxValue, setCheckBoxValue] = useState(
    fetchCommonData?.checkBoxValue
      ? fetchCommonData?.checkBoxValue
      : {
          openIndex: true,
          frozenIndex: false,
          completeIndex: false,
        }
  );
  React.useEffect(() => {
    dispatch(getProviderIdTypeDetails());
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    let localErr = errorMessagesInRedux?.searchScreenErrors
      ? errorMessagesInRedux?.searchScreenErrors
      : [];
    const get_Provider = getProvider({
      isCompleteSelected: checkBoxValue?.completeIndex,
      isFrozenSelected: checkBoxValue?.frozenIndex,
      isOpenSelected: checkBoxValue?.openIndex,
    });

    if (
      checkBoxValue.openIndex &&
      checkBoxValue.frozenIndex &&
      checkBoxValue.completeIndex
    ) {
      dispatch(get_Provider);
    } else if (checkBoxValue.openIndex && checkBoxValue.frozenIndex) {
      dispatch(get_Provider);
    } else if (checkBoxValue.openIndex && checkBoxValue.completeIndex) {
      dispatch(get_Provider);
    } else if (checkBoxValue.frozenIndex && checkBoxValue.completeIndex) {
      dispatch(get_Provider);
    } else if (checkBoxValue.openIndex) {
      dispatch(get_Provider);
    } else if (checkBoxValue.frozenIndex) {
      dispatch(get_Provider);
    } else if (checkBoxValue.completeIndex) {
      dispatch(get_Provider);
    } else {
      dispatch(get_Provider);
    }
    localErr = localErr.filter((item) => item.field !== 'resultNotFound');
  }, [checkBoxValue]);

  React.useEffect(() => {
    let arr;
    if (
      getProviderFromRedux &&
      Object.keys(getProviderFromRedux).length > 0 &&
      providerIdTypeDropDown &&
      Object.keys(providerIdTypeDropDown).length > 0
    ) {
      arr = getProviderFromRedux?.getProviderResponseVOs.map((item) => {
        const getIndex = providerIdTypeDropDown.findIndex(
          (element) => element.codeValueID.codeValue === item.providerIdTypeCd
        );
        return {
          ...item,
          providerIdTypeCd: providerIdTypeDropDown[getIndex]?.shortDescription,
        };
      });

      setTableData(arr);
    }
  }, [getProviderFromRedux, checkBoxValue, providerIdTypeDropDown]);

  React.useEffect(() => {
    var detailScreenErr = [];
    var localErr = errorMessagesInRedux?.searchScreenErrors
      ? errorMessagesInRedux?.searchScreenErrors
      : [];
    localErr = localErr.filter((item) => item.field !== 'NoSelectedRow');
    if (getProviderList && getProviderList.length > 0 && tableclick) {
      var detailScreenErr = [];
      var localErr = errorMessagesInRedux?.searchScreenErrors
        ? errorMessagesInRedux?.searchScreenErrors
        : [];
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      dispatch(
        handleErrorMessages({
          searchScreenErrors: [...new Set(localErr)],
          detailScreenErrors: detailScreenErr,
        })
      );
      settableclick(false);
      requestAnimationFrame(() => {
     // setTimeout(() => {
        redirectURLLink(
          '/providerReviewDetail',
          'Provider Review Detail',
          history,
          dispatch
        );
      });
    } else if (getProviderList && getProviderList.length == 0 && tableclick) {
      localErr = localErr.filter((item) => item.field !== 'resultNotFound');
      localErr.push({
        field: 'resultNotFound',
        errorType: 'resultNotFound',
        errorComponent: 'searchTypeComponent',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      detailScreenErr = errorMessagesInRedux?.detailScreenErrors
        ? errorMessagesInRedux?.detailScreenErrors
        : [];
    }
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: detailScreenErr,
      })
    );
  }, [getProviderList]);

  const getTableData = async (data, history, dispatch) => {
    dispatch(getProviderIdTypeDetails());
    if (Object.keys(data).length > 0) {
      const result = await dispatch(
        FETCHALLPROVIDERLIST({
          providerReviewSequenceNum: data?.providerReviewSeqNum,
        })
      );
      dispatch(
        getNdcMainGridDetail({
          providerReviewSeqNum: data?.providerReviewSeqNum,
        })
      );
    }
  };

  const [fullScreenView, setfullScreenView] = useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  // Tabhighlighter
  React.useEffect(() => {
    if (
      errorMessagesInRedux?.searchScreenErrors &&
      errorMessagesInRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/providerReview', true);
    } else {
      tabHighLigther('/providerReview', false);
    }
  }, [JSON.stringify(errorMessagesInRedux)]);

  function handleOnChangeEvent(val, name) {
    const detailScreenErr = [];
    let localErr = errorMessagesInRedux?.searchScreenErrors
      ? errorMessagesInRedux?.searchScreenErrors
      : [];
    localErr = localErr.filter((item) => item.field !== 'resultNotFound');
    dispatch(
      handleErrorMessages({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: detailScreenErr,
      })
    );
    if (name === 'openIndex') {
      setCheckBoxValue({
        ...checkBoxValue,
        [name]: val,
      });
      setCommonData({
        checkBoxValue: { ...checkBoxValue, [name]: val },
      });
    }
    if (name === 'frozenIndex') {
      setCheckBoxValue({
        ...checkBoxValue,
        [name]: val,
      });
      setCommonData({
        checkBoxValue: { ...checkBoxValue, [name]: val },
      });
    }
    if (name === 'completeIndex') {
      setCheckBoxValue({
        ...checkBoxValue,
        [name]: val,
      });
      setCommonData({
        checkBoxValue: { ...checkBoxValue, [name]: val },
      });
    }
  }

  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="ProviderReview"
    >
      <CustomSeparator parent1="Tasks" parent2="Provider Review" />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesInRedux?.searchScreenErrors?.length > 0
                  ? _.map(
                      errorMessagesInRedux?.searchScreenErrors,
                      (l) => l.message
                    )
                  : []
              ),
            ]}
          />
          <Spinner load={spinnerLoader} />
        </>
      )}

      {!fullScreenView ? (
        <div className="row">
          <div className="col-6 col-sm-12 col-md-6 col-lg-6 frr-checkbox-28per-width">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">Review Status</legend>
              <div className="form-wrapper db">
                <FormControlLabel
                  className="ml-0"
                  data-testid="open"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Open"
                  value={checkBoxValue.openIndex}
                  checked={checkBoxValue.openIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'openIndex')
                  }
                />
                <FormControlLabel
                  className="ml-0"
                  data-testid="frozen"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Frozen"
                  value={checkBoxValue.frozenIndex}
                  checked={checkBoxValue.frozenIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'frozenIndex')
                  }
                />
                <FormControlLabel
                  className="ml-0"
                  data-testid="complete"
                  control={<Checkbox color="primary" className="mr-2" />}
                  label="Complete"
                  value={checkBoxValue.completeIndex}
                  checked={checkBoxValue.completeIndex}
                  onChange={(e) =>
                    handleOnChangeEvent(e.target.checked, 'completeIndex')
                  }
                />
              </div>
            </fieldset>
          </div>
        </div>
      ) : (
        ''
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <TableGrid
            data-testid="onEditingStopped"
            rowSelection="multiple"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            isScrollOn
            onCellFocused={onCellFocused}
            columnDefs={TableHeaderForProviderReview}
            rowData={tableData || []}
            cellClickedListener={(e) => {
              dispatch(dispatchProviderFrozenComplete(''));
              dispatch(dispatchProblemCode(''));
              dispatch(dispatchcorrectionCode(''));
              dispatch(dispatchGetDetailData({}));
              dispatch(dispatchProviderReviewClaimHeader([]));
              settableclick(true);
              dispatch(dispatchBottonState(true));
              getTableData(e.data, history, dispatch);
            }}
            exportFile
            fileName="Provider Review"
            animateRows
            frameworkComponents={{
              ProviderNameRender: (cellInfo) => {
                if (
                  cellInfo.value !== null &&
                  cellInfo.value !== '' &&
                  cellInfo?.value?.length > 13
                ) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="labeler-tooltip">
                          {cellInfo.data.name}
                        </Tooltip>
                      }
                    >
                      <div>
                        {cellInfo.data.name &&
                          `${cellInfo.data.name.substring(0, 25)}...`}
                      </div>
                    </OverlayTrigger>
                  );
                }
                return <div>{cellInfo.value}</div>;
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProviderReview;
